import React from 'react';
import CenterImage from './../CenterImage/CenterImage';

const BlacklistedImage = () => (
  <CenterImage
    image={
      <svg
        width="96px"
        height="96px"
        viewBox="0 0 84 75"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g fill="none" fillRule="evenodd">
          <path fill="#FFF" d="M-678-131H762v1306H-678z" />
          <path fill="#FFF" d="M-546-63H630v587H-546z" />
          <path
            fill="#FFF"
            fillRule="nonzero"
            stroke="#365568"
            strokeLinecap="round"
            strokeWidth="2"
            d="M13.86 47.397L1.35 69.18a2.65 2.65 0 0 0 0 2.631 2.593 2.593 0 0 0 2.262 1.31h76.776a2.593 2.593 0 0 0 2.262-1.31 2.65 2.65 0 0 0 0-2.63L44.258 2.327A2.592 2.592 0 0 0 42 1c-.933 0-1.795.506-2.263 1.337L20.12 36.497"
          />
          <path
            fill="#7FBABA"
            d="M42 21a3 3 0 0 1 3 3v20a3 3 0 0 1-6 0V24a3 3 0 0 1 3-3zM42 55a3 3 0 0 1 0 6 3 3 0 0 1 0-6z"
          />
          <path
            fill="#DFEBEB"
            d="M62.738 39L81 71H41c12.527-.889 20.87-3.327 25.028-7.314C70.187 59.699 69.09 51.47 62.738 39z"
          />
        </g>
      </svg>
    }
  />
);

export default BlacklistedImage;
